import { FormDialog as CustomFormDialog } from '@globaleris/ui.library'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { FormDialogDefinitionProps } from '../../../hooks'
import { FormStateConfig } from './genericCustomFormDialog.model'

interface GenericCustomFormDialogProps {
  formStateConfig: FormStateConfig
  onClose: (formData: any) => void
  data?: any
  title: string
  subtitle?: string | React.ReactNode
}

export const GenericCustomFormDialog: React.FC<GenericCustomFormDialogProps> = ({
  formStateConfig,
  onClose,
  data,
  title,
  subtitle = ''
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'genericCustomFormDialog'])
  const { open, formMode, inputFields, okBtnLabel, cancelBtnLabel } = formStateConfig

  // Arma la definición del formulario
  const formDefinitionWithInputFields = useMemo<FormDialogDefinitionProps>(
    () => ({
      id: 'GENERIC_CUSTOM_FORM',
      sections: [
        {
          inputs: inputFields
        }
      ]
    }),
    [inputFields]
  )

  // Handler de cierre
  const onFormCloseHandler = (formData: any) => {
    onClose(formData)
  }

  return (
    <CustomFormDialog
      inputs={formDefinitionWithInputFields.inputs}
      sections={formDefinitionWithInputFields.sections}
      open={open}
      onClose={onFormCloseHandler}
      title={title}
      subtitle={subtitle}
      mode={formMode}
      inputData={data}
      okBtnLabel={okBtnLabel}
      cancelBtnLabel={cancelBtnLabel}
    />
  )
}
